import React from 'react';
import './terms.css'; // Still using the same CSS unless updated
import { useNavigate } from 'react-router-dom';
import GameHeader from '../header/header';

const AboutEpic = () => {
    const navigate = useNavigate();

    const handleAdminlogin = () => {
        window.history.back();
    };

    return (
        <div className="obtibg">
                <GameHeader />
                <div className="terms-container">
                    <div className="terms-content">
                        <h1>Welcome to Epic Games</h1>
                        <p>
                            Where creative imagination meets technical innovation. Since our founding in 2010, Epic Games has been a creative technology powerhouse dedicated to building captivating virtual worlds and interactive experiences that redefine the boundaries of digital entertainment.
                        </p>

                        <p>
                            At Epic Games, we believe in the transformative power of immersive storytelling and cutting-edge technology. Our teams of visionary designers, developers, and artists come together to craft environments that seamlessly merge reality with the fantastical, delivering adventures that excite the senses and expand the imagination.
                        </p>

                        <p>
                            As pioneers in immersive interactive media, we continuously push the envelope of what's possible. Our collaborations with creators and storytellers have resulted in dynamic, evolving digital worlds—not just places to escape, but platforms for exploration, connection, and discovery. Whether you're setting off on a heroic journey, teaming up with friends, or enjoying a peaceful escape, Epic Games offers worlds where anything is possible.
                        </p>

                        <p>
                            With a deep passion for innovation and a commitment to delivering extraordinary experiences, Epic Games is leading the charge in the future of spatial computing and interactive storytelling. Enter our worlds and unleash your imagination. Welcome to the future of interactive entertainment.
                        </p>
                    </div>
                </div>
        </div>
    );
};

export default AboutEpic;
